import {navigationEvents, useSubscribeEvents} from "@/shared/lib/events";
import {useSearchStore} from "@/Stores/Site/Search"; // Legacy

const PAGE_EVENTS = [navigationEvents.pageChanged];
const SEARCH_PAGE_PATH = "/search";

const isSearchPage = (pathname: string) =>
    pathname.replace(/\/+$/, "") === SEARCH_PAGE_PATH;

export const useResetSearchOnLeave = () => {
    useSubscribeEvents(PAGE_EVENTS, () => {
        if (isSearchPage(window.location.pathname)) return;

        useSearchStore.getState().resetSearch();
    });
};
